import React from 'react';
import { SavingsListPage } from './list';

export const SavingsModule = () => {
  return <SavingsListPage />;
};
